import { createApi } from '@reduxjs/toolkit/query/react';

import { PAYER_REQUEST_API_URL } from 'api/APIBase';
import { handleRTKQueryError } from 'services/Error';
import { getBaseQuery } from 'store/api/apiBaseQuery';

export const payerRequestApi = createApi({
    baseQuery: getBaseQuery(`${PAYER_REQUEST_API_URL}/admin`),
    reducerPath: 'payerRequestApi',
    endpoints: (build) => ({
        getRequestsForTreatment: build.query({
            query: ({ payerId, treatmentId }) => `${payerId}/treatment/${treatmentId}`,
            transformResponse: (response) =>
                response?.map((request) => ({
                    requestId: request.request_id,
                    requestNumber: request.request_number?.toString().padStart(6, '0'),
                    requestSubType: request.request_sub_type,
                    requestStatus: request.request_status,
                    createDate: request.create_date,
                    completedDate: request.completed_date,
                    assignedUpn: request.assigned_upn,
                    pbmOnly: request.pbm_only,
                })),
            transformErrorResponse: handleRTKQueryError('An error occurred retrieving requests.'),
        }),
    }),
});

export const { useGetRequestsForTreatmentQuery } = payerRequestApi;
